import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

type BeneficiaryListPercentCardProps = {
  percentVestedUnits: number;
};

const BeneficiaryListPercentCard: FC<BeneficiaryListPercentCardProps> = ({
  percentVestedUnits,
}) => {
  const { t } = useTranslate();

  return (
    <div className="card card-bordered card-stretch mt-0 h-100 d-flex justify-content-center">
      <div className="card-inner">
        <h6 className="overline-title-alt mb-2">
          <em className="icon ni ni-meter mr-2  fs-20px" />
          <span>
            {percentVestedUnits}%&nbsp;
            {t('UnitsVested')}
          </span>
        </h6>
        <div className="progress progress-md bg-light">
          <div
            className="progress-bar"
            data-progress={percentVestedUnits}
            style={{
              width: `${percentVestedUnits}%`,
            }}
          />
        </div>
        <div className="nk-fmg-status-info">
          <div className="float-md-left">0</div>
          <div className="float-md-right">100%</div>
        </div>
      </div>
    </div>
  );
};

export default BeneficiaryListPercentCard;
